import PropTypes from "prop-types";
import React from "react";

import { makeStyles } from "tss-react/mui";

import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import HelpContextIcon from "./HelpPanel/HelpContextIcon";

const useStyles = makeStyles()((theme) => ({
  Header: {
    fontSize: "1.1rem",
    backgroundColor: "#e8edf1",
    color: "black",
    margin: "0",
    borderRadius: 0,
    boxShadow: 0,
    fontWeight: 600,
    display: "flex",
    flexWrap: "wrap",
    padding: 0,
    paddingRight: "8px !important",
    paddingLeft: "8px !important",
  },
  HeaderTitle: {
    fontSize: 20,
    display: "inline-flex",
  },
}));

const CustomToolbar = ({ title, helpText, children }) => {
  const { classes } = useStyles();

  return (
    <Toolbar className={classes.Header}>
      <Box sx={{ display: "flex", flex: "1", alignItems: "center", paddingRight: "16px" }}>
        <Typography className={classes.HeaderTitle} component="div">
          {title}
        </Typography>
        {helpText && <HelpContextIcon screen={helpText} />}
      </Box>
      {children}
    </Toolbar>
  );
};

CustomToolbar.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  helpText: PropTypes.string,
  children: PropTypes.node,
};

export default CustomToolbar;
